export default from './notifications-page';



// WEBPACK FOOTER //
// ./app/containers/notifications-page/index.js